var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-flex"},[_c('PtMasterNav',{staticClass:"search-left-nav-wrap",attrs:{"service":_vm.navService},scopedSlots:_vm._u([{key:"aiLab",fn:function(){return [_c('div',{staticClass:"left-nav-ai-lab"})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }